import C from '../constants/app';
import {reportData} from '../utils/helpers';
export function reportAnalytics (payload){
    return(dispatch, getState) =>{
        if(payload) {
            if (getState().app.get(C.SSP_PERMISSIONS_LIST).canSendAnalytics) {
                reportData(...payload);
            }
        }
    };
}


// WEBPACK FOOTER //
// ./actions/analytics.js